/**
 * @name hasQueryParams
 * @description Search if an url already have query params
 * @param {string} url
 * @returns {boolean}
 */
export const hasQueryParams = url => url.includes('?');

/**
 * @name injectQueryParamToUrl
 * @description Takes an url as input and returns the url with query parameters injected
 * This function checks if the url already have query params
 * @param {string} key - The key of the query
 * @param {string} value - The value of the query
 * @param {string} url - The url to mutate
 */

export const injectQueryParamToUrl = ({ key, value, url }) => {
  const separator = hasQueryParams(url) ? '&' : '?';

  return `${url}${separator}${key}=${value}`;
};

export function buildUrlWithParameters(url, parameters) {
  if (!url) return '';

  if (!parameters) return url;

  const parametersToArray = Object.entries(parameters);
  const reducer = (urlAccumulated, [key, value]) =>
    injectQueryParamToUrl({ key, value, url: urlAccumulated });

  const urlWithParameters = parametersToArray.reduce(reducer, url);

  return urlWithParameters;
}

export const getParametersFromUrl = url => {
  if (!url) return {};

  const index = url.indexOf('?');

  if (index === -1) return {};

  const params = url.slice(index + 1).trim();
  if (!params) {
    return {};
  }

  const reducer = (accumulator, currentParam) => {
    const [key, value] = currentParam.split('=');
    return { ...accumulator, [key]: value };
  };

  return params.split('&').reduce(reducer, {});
};

export const getSourceFromUrlParameters = url =>
  getParametersFromUrl(url).source || '';

export const isUrlInternal = url => {
  if (!url) return false;
  if (
    url.startsWith(`${window.location.origin}/pdf/`) ||
    url.startsWith('https://www.doctrine.fr/pdf/') ||
    url.startsWith('/pdf/')
  )
    return false;
  return (
    url.startsWith(window.location.origin) ||
    url.startsWith('https://www.doctrine.fr') ||
    (url.startsWith('/') && !url.startsWith('/redirect_to_comment'))
  );
};
